import { useStore } from 'vuex'
import { computed } from 'vue'
export default function () {
  const store = useStore()
  const Menu = computed(() => store.getters['auth/userMenu'])
  return { Menu }
}
